<template>
    <div class="tabbed-menu d-flex align-items-stretch">
        <slot></slot>
    </div>
    
</template>

<script>
    export default {
        props: {
            //
        },

        data: function () {
            return {
                //
            }
        },
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    .tabbed-menu{
        border: .0625rem solid $gray-lighter;
        border-bottom: none;

        background: rgba(255,255,255,1);
        background: linear-gradient(to bottom, #ffffff 0%, #f1f1f1 100%);
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/TabbedMenu.vue